<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <mask id="path-1-inside-1_1683_969" fill="white">
    <path
      d="M4.07715 10.1895C6.58306 9.12083 9.41694 9.12083 11.9229 10.1895C12.6984 10.5202 13.4656 11.0136 15 12V15H1V12C2.53438 11.0136 3.30156 10.5202 4.07715 10.1895ZM8 1C9.933 1 11.5 2.567 11.5 4.5C11.5 6.433 9.933 8 8 8C6.067 8 4.5 6.433 4.5 4.5C4.5 2.567 6.067 1 8 1Z"
    />
  </mask>
  <path
    d="M4.07715 10.1895L3.48875 8.80967L3.48872 8.80969L4.07715 10.1895ZM11.9229 10.1895L12.5113 8.80969L12.5112 8.80967L11.9229 10.1895ZM15 12H16.5V11.1811L15.8111 10.7382L15 12ZM15 15V16.5H16.5V15H15ZM1 15H-0.5V16.5H1V15ZM1 12L0.188864 10.7382L-0.5 11.1811V12H1ZM4.07715 10.1895L4.66554 11.5692C6.79557 10.6609 9.20443 10.6609 11.3345 11.5692L11.9229 10.1895L12.5112 8.80967C9.62944 7.58076 6.37056 7.58076 3.48875 8.80967L4.07715 10.1895ZM11.9229 10.1895L11.3344 11.5692C11.9658 11.8385 12.6086 12.2459 14.1889 13.2618L15 12L15.8111 10.7382C14.3227 9.78135 13.4311 9.20197 12.5113 8.80969L11.9229 10.1895ZM15 12H13.5V15H15H16.5V12H15ZM15 15V13.5H1V15V16.5H15V15ZM1 15H2.5V12H1H-0.5V15H1ZM1 12L1.81114 13.2618C3.39142 12.2459 4.03424 11.8385 4.66558 11.5692L4.07715 10.1895L3.48872 8.80969C2.56887 9.20197 1.67735 9.78135 0.188864 10.7382L1 12ZM8 1V2.5C9.10457 2.5 10 3.39543 10 4.5H11.5H13C13 1.73858 10.7614 -0.5 8 -0.5V1ZM11.5 4.5H10C10 5.60457 9.10457 6.5 8 6.5V8V9.5C10.7614 9.5 13 7.26142 13 4.5H11.5ZM8 8V6.5C6.89543 6.5 6 5.60457 6 4.5H4.5H3C3 7.26142 5.23858 9.5 8 9.5V8ZM4.5 4.5H6C6 3.39543 6.89543 2.5 8 2.5V1V-0.5C5.23858 -0.5 3 1.73858 3 4.5H4.5Z"
    fill="currentColor"
    mask="url(#path-1-inside-1_1683_969)"
  />
</svg>
